function cn(...xs) {
  return xs.filter(Boolean).join(" ");
}

const tabRowInsetClass = "border-b border-white/10 px-3 sm:px-5 md:px-6";

export const COMPOSER_TABS = [
  { id: "post", label: "Post", disabled: false },
  { id: "media", label: "Images & Video", disabled: false },
  { id: "link", label: "Link", disabled: true },
  { id: "poll", label: "Poll", disabled: true },
];

/** Plain text tabs — Reddit-style row, Clubs dark palette. */
export default function ClubFeedComposerTabList({ activeId, onSelect }) {
  return (
    <div className={cn(tabRowInsetClass, "pt-1")}>
      <div
        className="-mb-px flex gap-0 overflow-x-auto scrollbar-hide"
        role="tablist"
        aria-label="Composer mode"
      >
        {COMPOSER_TABS.map((tab) => {
          const active = activeId === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              aria-disabled={tab.disabled}
              title={tab.disabled ? "Coming soon" : undefined}
              onClick={() => onSelect(tab)}
              className={cn(
                "shrink-0 border-b-2 px-3 py-2.5 text-[13px] font-medium transition-colors duration-150 sm:px-4",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/15 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0b101a]",
                tab.disabled && "cursor-not-allowed text-white/25",
                active && !tab.disabled
                  ? "border-white/40 text-white"
                  : !tab.disabled
                    ? "border-transparent text-white/45 hover:text-white/70"
                    : "border-transparent text-white/25"
              )}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
